import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Categorias',
    links: [
      { label: 'Calçados', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
      { label: 'Moletons', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
      { label: 'Camisetas', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
      { label: 'Jaquetas', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
    ],
  },
  {
    title: 'Links Rápidos',
    links: [
      { label: 'Calças/Bermudas', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
      { label: 'Chapéus/Bonés', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
      { label: 'Conjuntos', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
      { label: 'Acessórios', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
    ],
  },
  {
    title: 'Guia de Compras',
    links: [
      { label: 'Guia Definitivo 2026', url: '/artigo/cssbuy-spreadsheet-guia-completo-2026', internal: true },
      { label: 'CSSBuy vs Pandabuy', url: '/artigo/cssbuy-spreadsheet-vs-pandabuy-2026', internal: true },
      { label: 'Tutorial Iniciantes', url: '/artigo/cssbuy-spreadsheet-tutorial-iniciantes', internal: true },
      { label: 'Segurança e Confiança', url: '/artigo/cssbuy-spreadsheet-e-seguro', internal: true },
    ],
  },
  {
    title: 'Mais Artigos SEO',
    links: [
      { label: 'Como Usar o CSSBuy', url: '/artigo/como-usar-cssbuy-spreadsheet-comprar-china', internal: true },
      { label: 'Dicas de Economia', url: '/artigo/economizar-dinheiro-cssbuy-spreadsheet', internal: true },
      { label: 'Shipping Barato', url: '/artigo/shipping-barato-china-cssbuy', internal: true },
      { label: 'Site Principal', url: 'https://kaspreadsheet.com/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 mb-16">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 tracking-wide uppercase">
                {group.title}
              </h4>
              <div className="w-8 h-px bg-foreground-300 mb-4"></div>
              <ul className="space-y-3">
                {group.links.map((link) =>
                  link.internal ? (
                    <li key={link.label}>
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 pt-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex flex-col items-center sm:items-start gap-1">
            <div className="flex items-baseline gap-2">
              <span className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 tracking-tight">
                CSSBuy
              </span>
              <span className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 tracking-tight">
                Spreadsheet
              </span>
            </div>
            <div className="w-12 h-px bg-foreground-300"></div>
            <p className="text-xs text-foreground-500">Site de SEO independente</p>
          </div>

          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} cssbuyspreadsheet.cc
          </p>

          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer">
              <i className="ri-global-line text-lg"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer">
              <i className="ri-shopping-cart-2-line text-lg"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:text-foreground-950 hover:bg-background-300 transition-colors cursor-pointer">
              <i className="ri-star-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}